import React from "react";
import ReactDom from "react-dom";

import { extendObservable, observable, computed, action, reaction, autorun } from 'mobx';
import { observer, inject } from 'mobx-react';

import autoclass from 'autoclass-decorator';
import BaseComponent from 'base-component';
import BaseViewStore from 'base-viewstore';

import {Mixin, mix} from 'mixwith';

import {ViewControllerMixin} from 'layout-component';

import DataModel from 'simgate-datamodel';

import ProjectDomainStore from 'project-domain-store';
import SimDomainStore from 'sim-domain-store';

@observer
export class MenuBar extends BaseComponent {
  render(){
    const {viewMap, clickItem, currentView, currentViewId, currentRound} = this.props;
    let items = [];
    Object.keys( viewMap ).reduce( (acc,k) => {
        const v = viewMap[k]
        let element = null;
        if(typeof v === "function"){
            element = { id: k, Component: v };
        } 
        else if(v.show || (v.menu && v.menu.show)){
            element = v;
        } 
        else if(v.onClick || v.clickItem){
            element =  Object.assign({}, v, {id: k}, {clickItem: v.onClick || v.clickItem });
        }

        if(!element) {
            return;
        }

        element.iconClass = element.icon || (element.contentModel && element.contentModel.icon) || "";
        element.menu = Object.assign( {clickItem: clickItem}, element, element.menu );
        element.itemStatus = (currentViewId && element.menu.id === currentViewId) || (currentView && currentView.id === element.menu.id) ? "active" : "inactive";

        items.push(element);
        return [];
    }, []);
    
    function getItem(css, item) {
        return (<div className={"item " + css + " " + item.itemStatus + " " + item.menu.id} onClick={e => !!item.menu.clickItem && item.menu.clickItem(item, viewMap) } disabled={item.menu.hasOwnProperty('enabled') ? !item.menu.enabled : false}>
            <div className="icon"></div>
            <div className="label">{item.menu.displayName || item.menu.id}</div>
        </div>);
    }

    return (
        <div className="menu">

            <div className="item message round">{!!currentRound && currentRound.displayName || currentRound.id}</div>
            
            <div className="sub-menu">
              {items.map( (view, index) => {
                  return (
                      <div key={"" + view.menu.id + index} className={"item " + view.iconClass + " " + view.itemStatus + " " + view.menu.id} onClick={e => !!view.menu.clickItem && view.menu.clickItem(view, viewMap) } disabled={view.menu.hasOwnProperty('enabled') ? !view.menu.enabled : false}>
                          <div className="icon"></div>
                          <div className="label">{view.menu.displayName || view.menu.id}</div>
                      </div>
                  )
              })}
            </div>
        </div>
    )
  }
}


export class DefaultShellViewStore extends mix(BaseViewStore).with(ViewControllerMixin){

    isInitilized = false;

  constructor(){
    super(...arguments);

    const {
      contentModel: shell,
      simulation,
      dataModel: {
        domainStore: simDomainStore
      },
      projectDomainStore,
      parentPathId,
      application
    } = this.props;

  }

  @action.bound completeState(){
    const {
      dataModel: {
        domainStore: simDomainStore
      }
    } = this.props;

    simDomainStore.completeTask();
  }

  @computed get currentRound(){
    const {
      simulation,
      dataModel: {
        domainStore: simDomainStore
      }
    } = this.props;

    const round = simulation.rounds[0];
    return round;
  }
  @computed get currentTeamState(){
    const {
      dataModel: {
        domainStore: simDomainStore
      }
    } = this.props;
    return this.currentRound.teamStates.find( ts => ts.id === simDomainStore.teamStateName ) || this.currentRound.teamStates[0];
  }
  @computed get currentTeamName() {
    const projectDomainStore = this.props.projectDomainStore;
    
    return (projectDomainStore.context && projectDomainStore.context.team && projectDomainStore.context.team.name) || "-";
  }
  @computed get currentSessionName() {
    const projectDomainStore = this.props.projectDomainStore;
    
    return (projectDomainStore.context && projectDomainStore.context.sessionName) || "-";
  }
  @computed get viewMap(){
    const {
      dataModel,
      dataModel: {
        domainStore: simDomainStore
      }
    } = this.props;

    if(!simDomainStore.pathId || !simDomainStore.teamStateName) return {
      "loading": {
        id: "loading",
        Component: () => <div>Loading...</div>
      }
    }

    const tasks = this.currentTeamState.tasks;
    return tasks && tasks.reduce( (acc, task) => {
      acc[task.id] = {
        id: task.id,
        contentModel: task,
        menu: {
          get show(){ return true }, // can be computed based on activity
          get enabled(){ return true }, // can be computed based on activity
          displayName: task.displayTitle || task.id
        },
        dataModel: dataModel,
        viewMode: "simulation"
      };
      return acc;
    }, {})
  }
  @action.bound logout() {
      const {
          contentModel, 
          dataModel: {
            domainStore: projectDomainStore
          },
      } = this.props;
      const modalViewStore = window.application.modalViewStore;

      //just in case we're already signed in :-)
      if(!(process && process.env && process.env.mockMode)) projectDomainStore.refreshContext();

      modalViewStore.setModal({
          title: "Are you sure you want to logout?",
          message: "",
          confirmLabel: 'Logout',
          confirmBtnClass: 'green check-a',
          cancelLabel: 'Cancel',
          cancelBtnClass: 'red times-b',
          onConfirmFunc: () => { projectDomainStore.simgate.signOut().then(() => window.location.reload()).catch(() => window.location.reload()); }
      })
  }
  
    @action.bound updateState() {
      const {
          contentModel, 
          dataModel: {
              domainStore
          },
      } = this.props;
      
      const viewMap = this.viewMap;
      const selectView = this.selectView;
      let self = this;
  
      let first = null;
      let home = null;
      let inputs = [];
      
      for(let i in viewMap) {
        first = viewMap[i];
        break;
      }
    
        selectView(first, viewMap);
    }
}

@observer
//@autoclass
export class DefaultShellComponent extends BaseComponent{
  static ViewStore = DefaultShellViewStore
  render(){
    const {
      contentModel: shell,
      simulation,
      dataModel,
      projectDomainStore,
      parentPathId,
      application
    } = this.props;

    const {
      viewMap,
      selectView,
      clearView,
      SelectedView,
      currentRound,
      currentTeamState,
      currentTeamName,
      currentSessionName,
      completeState,
      logout,
      isInitilized,
      updateState,
    } = this.viewStore

    if(!SelectedView && !viewMap["loading"] && !isInitilized) {
        this.viewStore.isInitilized = true;
        updateState();
    }

    return <div className="app-shell">
    <div className="content">
        {/*<div className="side-bar">
            <div className="logo-bar">
                <div className="logo"></div>
            </div>
            <div className="tagline">Oil &amp; Gas</div>
            <MenuBar viewMap={viewMap} clickItem={ selectView } currentRound={currentRound} />
          </div>*/}
          <div className="activity-area">
            {!SelectedView 
              ? <div dangerouslySetInnerHTML={{__html: shell.body }} ></div>
              : <SelectedView />}
          </div>
      </div>
      <div className="footer">
          <div className="actions">
              <div className="action" onClick={logout}>Logout</div>
          </div>

      </div>
    </div>
  }
}

export const Component = DefaultShellComponent;
export default Component;


// WEBPACK FOOTER //
// ./app_modules/assessment-shell/component.js